import { FC, PropsWithChildren, useCallback, useEffect, useState } from 'react'
import { Card } from 'antd'
import icon5 from '@/assets/images/workbench/drgzqk.png'

type SpItemProp = FC<PropsWithChildren<{
  label: string
  value: string | number
}>>
const SpItem: SpItemProp = ({label, value}) => {
  return (
    <div className='grow-1 text-center'>
      <div className='font-700 font-23'>{value}</div>
      <div className='text-777 font-14'>{label}</div>
    </div>
  )
}

type PropType = FC<PropsWithChildren<{
  count: any
  drzgqk: any
  pjclsc: any
  className?: string
}>>

const TopRight: PropType = ({count, drzgqk, pjclsc, className}) => {

  return (
    <div className={className}>
      <Card size="small">
        <div className='flex ptb-4'>
          <div className='pl-10 mr-10 ml-10'>
              <img src={icon5} alt=''/>
            </div>
          <SpItem label='审批单据' value={drzgqk.CNT_DRZGQK_SPDJ || 0} />
          <SpItem label='审批通过' value={drzgqk.CNT_DRZGQK_SPTG || 0} />
          <SpItem label='审批驳回' value={drzgqk.CNT_DRZGQK_SPBH || 0} />
          <SpItem label='平均处理时长' value={pjclsc.CNT_DRZGQK_PJCLSC || 0} />
        </div>
      </Card>
    </div>
  )
}

export default TopRight
